var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pb-0 pt-0"
                },
                [_vm._v(" Manage SSL Certificates ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("services-search", {
                model: {
                  value: _vm.search,
                  callback: function callback($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                {
                  staticClass: "card-borderless"
                },
                [
                  _c("gg-card-header", [
                    _c(
                      "span",
                      [
                        _c(
                          "gg-card-title",
                          {
                            staticClass: "d-inline-flex"
                          },
                          [_c("h4", [_vm._v("My SSL Certificates")])]
                        )
                      ],
                      1
                    ),
                    _c(
                      "span",
                      [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              "aria-label": "Refresh SSL certificates.",
                              loading: _vm.loading || _vm.runningQueue
                            },
                            on: {
                              click: _vm.updateSslList
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-refresh")])],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "gg-card-text",
                    [
                      _c(
                        "gg-loading",
                        {
                          attrs: {
                            loading: !_vm.servicesPopulated,
                            type: "table"
                          }
                        },
                        [
                          _c("v-data-table", {
                            attrs: {
                              loading:
                                !_vm.servicesPopulated ||
                                _vm.loading ||
                                _vm.runningQueue,
                              headers: _vm.headers,
                              items: _vm.mergedSslList,
                              search: _vm.search,
                              "footer-props": {
                                itemsPerPageOptions: this.pagination
                              },
                              "item-key": "ssl_id"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.domain",
                                fn: function fn(_ref) {
                                  var item = _ref.item
                                  return [
                                    item.status === "Active"
                                      ? _c(
                                          "div",
                                          [
                                            item.isAuto
                                              ? _c("router-link", {
                                                  attrs: {
                                                    custom: "",
                                                    to: {
                                                      name: "ssl_create",
                                                      query: {
                                                        d: item.servername,
                                                        sid: item.serviceId,
                                                        cp: item.cpUsername
                                                      }
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function fn(_ref2) {
                                                          var navigate =
                                                            _ref2.navigate
                                                          return [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "ggs-item-title primary--text",
                                                                attrs: {
                                                                  role: "link",
                                                                  "aria-label":
                                                                    "Manage Certificate"
                                                                },
                                                                on: {
                                                                  click: navigate,
                                                                  keypress: function keypress(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      !$event.type.indexOf(
                                                                        "key"
                                                                      ) &&
                                                                      _vm._k(
                                                                        $event.keyCode,
                                                                        "enter",
                                                                        13,
                                                                        $event.key,
                                                                        "Enter"
                                                                      )
                                                                    ) {
                                                                      return null
                                                                    }
                                                                    return navigate(
                                                                      $event
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.domain
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              : _c("router-link", {
                                                  attrs: {
                                                    to: "/ssl/".concat(
                                                      item.ssl_id
                                                    ),
                                                    custom: ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function fn(_ref3) {
                                                          var navigate =
                                                            _ref3.navigate
                                                          return [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "ggs-item-title primary--text",
                                                                attrs: {
                                                                  role: "link",
                                                                  "aria-label":
                                                                    "Manage Certificate"
                                                                },
                                                                on: {
                                                                  click: navigate,
                                                                  keypress: function keypress(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      !$event.type.indexOf(
                                                                        "key"
                                                                      ) &&
                                                                      _vm._k(
                                                                        $event.keyCode,
                                                                        "enter",
                                                                        13,
                                                                        $event.key,
                                                                        "Enter"
                                                                      )
                                                                    ) {
                                                                      return null
                                                                    }
                                                                    return navigate(
                                                                      $event
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.domain
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                          ],
                                          1
                                        )
                                      : _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "ggs-item-title",
                                              attrs: {
                                                href: "#"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.domain))]
                                          )
                                        ])
                                  ]
                                }
                              },
                              {
                                key: "item.status",
                                fn: function fn(_ref4) {
                                  var item = _ref4.item
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "pb-1",
                                        attrs: {
                                          small: "",
                                          color: _vm.statusColor(item.status)
                                        }
                                      },
                                      [_vm._v("mdi-circle")]
                                    ),
                                    _vm._v(" " + _vm._s(item.status) + " ")
                                  ]
                                }
                              },
                              {
                                key: "item.name",
                                fn: function fn(_ref5) {
                                  var item = _ref5.item
                                  return [
                                    _c("div", [
                                      _vm.isAlphaSSL(item.name)
                                        ? _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  "/static/img/amui/globalsign-logo-eye.png",
                                                width: "24px",
                                                alt: "GlobalSign Logo"
                                              }
                                            }),
                                            _vm._v(" GlobalSign ")
                                          ])
                                        : _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  "/static/img/amui/le-logo-lockonly.png",
                                                width: "28px",
                                                alt: "Let's Encrypt Logo"
                                              }
                                            }),
                                            _vm._v(" Let's Encrypt ")
                                          ])
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "item.renewaldate",
                                fn: function fn(_ref6) {
                                  var item = _ref6.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRenewalDate(
                                            _vm.parseRenewalDate(
                                              item.renewaldate
                                            )
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item.actions",
                                fn: function fn(_ref7) {
                                  var item = _ref7.item
                                  return [
                                    item.status === "Active" && item.isAuto
                                      ? _c(
                                          "gg-btn",
                                          {
                                            attrs: {
                                              to: {
                                                name: "ssl_create",
                                                query: {
                                                  d: item.servername,
                                                  sid: item.serviceId,
                                                  cp: item.cpUsername
                                                }
                                              }
                                            }
                                          },
                                          [_vm._v(" Upgrade ")]
                                        )
                                      : item.status === "Active"
                                      ? _c(
                                          "gg-btn",
                                          {
                                            attrs: {
                                              to: "/ssl/".concat(item.ssl_id)
                                            }
                                          },
                                          [_vm._v(" Manage ")]
                                        )
                                      : _c(
                                          "gg-btn",
                                          {
                                            attrs: {
                                              disabled: ""
                                            }
                                          },
                                          [_vm._v(" Manage ")]
                                        )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }